export default "__VITE_ASSET__BfwY7H_8__"